/*--------------------------------------------------------------
# JS Swiper
--------------------------------------------------------------*/

import Swiper from 'swiper';
import { Scrollbar, Thumbs, EffectFade } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", function () {
    window.initSwiperBase = (selector, index) => {
        const element = document.querySelector(selector);

        if (element) {
            const scrollbar = element.closest('.swiper').querySelector('.swiper-scrollbar');

            new Swiper(element, {
                modules: [Scrollbar],
                slidesPerView: 'auto',
                spaceBetween: 15,
                breakpoints: {
                    1399: {
                        slidesPerView: 6,
                    },
                    1199: {
                        slidesPerView: 5,
                    },
                    992: {
                        slidesPerView: 4,
                    },
                },
                scrollbar: {
                    el: scrollbar,
                    draggable: true,
                },
                observer: true,
                observeParents: true,
            });
        }
    };

    window.initSwiperGalleryWithThumbs = (galleryWrapper) => {
        const galleryElement = galleryWrapper.querySelector('.is-gallery');
        const thumbsElement = galleryWrapper.querySelector('.is-thumbs');

        if (!galleryElement || !thumbsElement) return;

        const thumbs = new Swiper(thumbsElement, {
            //loop: true,
            spaceBetween: 15,
            breakpoints: {
                1599: { slidesPerView: 5 },
                1299: { slidesPerView: 3 },
                768: { slidesPerView: 2 },
                0: { slidesPerView: 1 }
            },
            freeMode: true,
            watchSlidesProgress: true,
            observer: true,
            observeParents: true,
        });

        const gallery = new Swiper(galleryElement, {
            modules: [Thumbs, EffectFade],
            loop: true,
            effect: "fade",
            allowTouchMove: false,
            observer: true,
            observeParents: true,
            thumbs: { swiper: thumbs },
        });

        const updateSwiperContent = (mediaUrls, videoFrame) => {
            const galleryWrapperEl = gallery.el.querySelector('.swiper-wrapper');
            const thumbsWrapperEl = thumbs.el.querySelector('.swiper-wrapper');

            if (!galleryWrapperEl || !thumbsWrapperEl) return;

            galleryWrapperEl.innerHTML = '';
            thumbsWrapperEl.innerHTML = '';

            if (mediaUrls.length > 0) {
                const firstImageUrl = mediaUrls.shift();
                galleryWrapperEl.insertAdjacentHTML('beforeend', `
                    <div class="swiper-slide">
                        <img class="img-fluid object-fit-contain rounded" src="${firstImageUrl}" alt="Image">
                    </div>
                `);
                thumbsWrapperEl.insertAdjacentHTML('beforeend', `
                    <div class="swiper-slide">
                        <img class="img-fluid object-fit-contain rounded" src="${firstImageUrl}" alt="Thumbnail">
                    </div>
                `);
            }
        
            if (videoFrame) {
                galleryWrapperEl.insertAdjacentHTML('beforeend', `
                    <div class="swiper-slide">${videoFrame}</div>
                `);
                thumbsWrapperEl.insertAdjacentHTML('beforeend', `
                    <div class="swiper-slide">
                        <span class="video-thumb">🎥 Vidéo</span>
                    </div>
                `);
            }
        
            mediaUrls.forEach((url) => {
                galleryWrapperEl.insertAdjacentHTML('beforeend', `
                    <div class="swiper-slide">
                        <img class="img-fluid object-fit-contain rounded" src="${url}" alt="Image">
                    </div>
                `);
                thumbsWrapperEl.insertAdjacentHTML('beforeend', `
                    <div class="swiper-slide">
                        <img class="img-fluid object-fit-contain rounded" src="${url}" alt="Thumbnail">
                    </div>
                `);
            });

            gallery.loopDestroy();
            thumbs.loopDestroy();

            gallery.loopCreate();
            thumbs.loopCreate();

            gallery.update();
            thumbs.update();
        };

        const handleSelectionChange = (mediasData, videoData) => {
            const mediaUrls = mediasData ? Object.values(mediasData).map(media => media.original_url) : [];
            const videoFrame = videoData || null;
            updateSwiperContent(mediaUrls, videoFrame);
        };

        document.querySelectorAll(".is-swiper-switch-onclick").forEach(option => {
            option.addEventListener("click", () => {
                const mediasData = option.getAttribute("data-medias") ? JSON.parse(option.getAttribute("data-medias")) : null;
                const videoData = option.getAttribute("data-video") ? JSON.parse(option.getAttribute("data-video")) : null;
                handleSelectionChange(mediasData, videoData);
            });
        });

        document.querySelectorAll(".is-swiper-switch-onchange").forEach(select => {
            select.addEventListener("change", (event) => {
                const selectedOption = event.target.selectedOptions[0];
                const mediasData = selectedOption.getAttribute('data-medias') ? JSON.parse(selectedOption.getAttribute('data-medias')) : null;
                const videoData = selectedOption.getAttribute('data-video') ? JSON.parse(selectedOption.getAttribute('data-video')) : null;
                handleSelectionChange(mediasData, videoData);
            });
        });
    };

    if (document.body.classList.contains("body-home")) {
        const slides = document.querySelectorAll('#circuits .slide');
        const contents = document.querySelectorAll('#circuits .item');

        slides.forEach((slide) => {
            slide.addEventListener('click', () => {
                const targetId = slide.getAttribute('data-target');
                contents.forEach(content => content.style.display = 'none');
                const targetContent = document.getElementById(targetId);
                if (targetContent) targetContent.style.display = 'flex';

                slides.forEach(s => s.classList.remove('active'));
                slide.classList.add('active');
            });
        });

        initSwiperBase('#offers .swiper .swiper-container');
        initSwiperBase('#circuits .swiper .swiper-container');

        // Initialize offres swiper for mobile
        const offresSwiper = document.querySelector('#offres-swiper .swiper-container');
        if (offresSwiper) {
            const scrollbar = document.querySelector('#offres-swiper .swiper-scrollbar');
            
            new Swiper(offresSwiper, {
                modules: [Scrollbar],
                slidesPerView: 1.2,
                spaceBetween: 15,
                centeredSlides: true,
                scrollbar: {
                    el: scrollbar,
                    draggable: true,
                },
                observer: true,
                observeParents: true,
            });
        }

        // Initialize promos swiper for mobile
        const promosSwiper = document.querySelector('#promos-swiper .swiper-container');
        if (promosSwiper) {
            const scrollbar = document.querySelector('#promos-swiper .swiper-scrollbar');
            
            new Swiper(promosSwiper, {
                modules: [Scrollbar],
                slidesPerView: 1.2,
                spaceBetween: 15,
                centeredSlides: true,
                scrollbar: {
                    el: scrollbar,
                    draggable: true,
                },
                observer: true,
                observeParents: true,
            });
        }

        // Initialize instagram swiper for mobile
        const instagramSwiper = document.querySelector('#instagram-swiper .swiper-container');
        if (instagramSwiper) {
            const scrollbar = document.querySelector('#instagram-swiper .swiper-scrollbar');
            
            new Swiper(instagramSwiper, {
                modules: [Scrollbar],
                slidesPerView: 1.2,
                spaceBetween: 15,
                centeredSlides: true,
                scrollbar: {
                    el: scrollbar,
                    draggable: true,
                },
                observer: true,
                observeParents: true,
            });
        }
    }

    if (document.body.classList.contains("body-groupece")) {
        const slides = document.querySelectorAll('#circuits .slide');
        const contents = document.querySelectorAll('#circuits .item');

        slides.forEach((slide) => {
            slide.addEventListener('click', () => {
                const targetId = slide.getAttribute('data-target');
                contents.forEach(content => content.style.display = 'none');
                const targetContent = document.getElementById(targetId);
                if (targetContent) targetContent.style.display = 'flex';

                slides.forEach(s => s.classList.remove('active'));
                slide.classList.add('active');
            });
        });

        initSwiperBase('#circuits .swiper .swiper-container');
    }
    
    if (document.body.classList.contains("body-promos")) {
        const slides = document.querySelectorAll('#promotions .slide');
        const contents = document.querySelectorAll('#promotions .item');

        slides.forEach((slide) => {
            slide.addEventListener('click', () => {
                const targetId = slide.getAttribute('data-target');
                contents.forEach(content => content.style.display = 'none');
                const targetContent = document.getElementById(targetId);
                if (targetContent) targetContent.style.display = 'flex';

                slides.forEach(s => s.classList.remove('active'));
                slide.classList.add('active');
            });
        });

        initSwiperBase('#promotions .swiper .swiper-container');
    }

    document.querySelectorAll('.gallery').forEach(galleryWrapper => {
        initSwiperGalleryWithThumbs(galleryWrapper);
    });
});
